import { PROMOTION_CONSTRAINTS } from './constraints.js';
import { promotionPercentSchema } from './percent-schema.js';
export const promotionAccountPctSchema = promotionPercentSchema(PROMOTION_CONSTRAINTS.accountPct.label)
    .nullable()
    .optional();
//# sourceMappingURL=promotion-account-pct-schema.js.map